/**
 * SearchService class
 */
export class WindowService {

    /**
     * Returns the width of the client's viewport
     *
     * @returns {number}
     */
    static width () {
        return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }

    /**
     * Returns the height of the client's viewport
     *
     * @returns {number}
     */
    static height () {
        return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    }

    /**
     * Returns breakpoint sizes
     *
     * @returns {{xs: number, sm: number, md: number}}
     */
    static get breakpoints () {
        return {
            xs: 768,
            sm: 991,
            md: 1024,
            lg: 1200
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/WindowService.js